import colors from '../../theme/foundations/colors'
import {fonts} from '../../theme/foundations/fonts'
import sizes from '../../theme/foundations/sizes'
import {pxToRem} from '../../utills/pxToRem'

export const pnftitle = {
    fontFamily: fonts.primary,
    fontSize: pxToRem(119.13),
    fontWeight: 600,
    letterSpacing: pxToRem(7.45),
    color: 'black',
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(62.44),
        letterSpacing: pxToRem(3.9)
    }
}
export const pnfsubtitle = {
    fontFamily: fonts.primary,
    fontSize: pxToRem(30),
    letterSpacing: pxToRem(4),
    color: 'black',
    fontWeight: 600,
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(22),
        letterSpacing: pxToRem(3)
    }
}
export const pnfmessage = {
    fontFamily: fonts.primary,
    margin: pxToRem(20),
    letterSpacing: pxToRem(1),
    color: 'black',
    fontWeight: 400,
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(14),
        margin: pxToRem(14)
    }
}
export const pnfImageContainer = {
    marginTop: pxToRem(10),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    img: {
        [`@media (min-width: ${sizes.container.lg})`]: {
            marginTop: pxToRem(-72)
        }
    }
}

export const recommendedProductsContainer = {
    [`@media (min-width: ${sizes.container.lg})`]: {
        pt: pxToRem(10)
    },
    [`@media (max-width: ${sizes.container.md})`]: {
        py: pxToRem(11)
    },
    '& .recommendation-title': {
        px: {base: pxToRem(11), md: pxToRem(20), xl: pxToRem(45)}
    },
    '& .reco-products': {
        px: {base: pxToRem(11), md: pxToRem(20), xl: pxToRem(45)}
    },
    '& .arrowLeft': {
        left: {base: pxToRem(11), md: pxToRem(30)}
    },
    '& .arrowRight': {
        right: {base: pxToRem(11), md: pxToRem(30)}
    }
}
